export const jobPositionsSk = {
  jobCategories: {
    'Others': 'Ostatné',
    'administration': 'Administratíva',
    'automotive_industry': 'Automobilový priemysel',
    'other_manufacturing': 'Iné výrobné odvetvia',
    'banking_leasing_insurance': 'Bankovníctvo, leasing a poisťovníctvo',
    'civil_protection_security': 'Civilná ochrana a bezpečnosť',
    'auxiliary_work_temp_jobs': 'Pomocné práce a brigády',
    'tourism_hospitality': 'Cestovný ruch, gastro, hoteliérstvo',
    'chemical_industry': 'Chemický priemysel',
    'transport_logistics': 'Špedícia, doprava a logistika',
    'wood_processing': 'Drevospracujúci priemysel',
    'economics_finance_accounting': 'Ekonomika, financie, účtovníctvo',
    'electrical_engineering_energy': 'Elektrotechnika a energetika',
    'it_hardware': 'Informatika - hardware',
    'it_software': 'Informatika - software',
    'it_system_administration': 'Informatika - správa systémov',
    'human_resources': 'Ľudské zdroje a personalistika',
    'quality_management': 'Manažment kvality',
    'marketing_advertising_pr': 'Marketing, reklama, PR',
    'sales': 'Obchod',
    'agriculture_forestry': 'Poľnohospodárstvo a lesné hospodárstvo',
    'food_industry': 'Potravinárstvo',
    'law_legislation': 'Právo a legislatíva',
    'translation_interpretation': 'Prekladateľstvo a tlmočníctvo',
    'education': 'Vzdelávanie a školstvo',
    'services': 'Služby',
    'social_services': 'Sociálne služby',
    'public_administration': 'Štátna a verejná správa',
    'real_estate_construction': 'Reality a stavebníctvo',
    'engineering_technology': 'Strojárstvo, technika a rozvoj',
    'telecommunications': 'Telekomunikácie',
    'textile_clothing_industry': 'Textilný, kožiarsky a odevný priemysel',
    'art_culture': 'Umenie a kultúra',
    'science_research': 'Veda a výskum',
    'environment_water_management': 'Životné prostredie a vodohospodárstvo',
    'top_management': 'Vrcholový manažment',
    'production': 'Výroba',
    'customer_support': 'Zákaznícka podpora',
    'healthcare_pharmacy': 'Zdravotníctvo a farmácia',
    'media_journalism': 'Média a žurnalistika'
  },
  jobPositions: {
    'Others': 'Ostatné',
    'administrative_assistant': 'Administratívny pracovník',
    'online_store_administrator': 'Administrátor internetového obchodu',
    'archivist': 'Archivár',
    'assistant': 'Asistent',
    'office_manager': 'Office manažér',
    'car_wash_worker': 'Pracovník autoumývarne',
    'receptionist': 'Recepčná, recepčný',
    'officer': 'Referent',
    'sales_officer': 'Referent odbytu',
    'registry_management_officer': 'Referent správy registrov',
    'contract_management_officer': 'Referent správy zmlúv',
    'secretary': 'Sekretárka',
    'technical_administrative_worker': 'Technickoadministratívny pracovník',
    'phone_operator': 'Telefonický operátor',
    'car_upholsterer': 'Autočalúnnik',
    'auto_electrician': 'Autoelektrikár',
    'auto_body_repair_specialist': 'Autoklampiar',
    'automotive_designer': 'Autokonštruktér',
    'auto_mechanic': 'Automechanik',
    'auto_glass_technician': 'Autosklár',
    'electromechanic': 'Elektromechanik',
    'maintenance_engineer': 'Inžinier údržby',
    'inspector': 'Kontrolór',
    'painter_lacquerer': 'Lakýrnik, lakovač',
    'production_operator': 'Operátor výroby',
    'tire_service_worker': 'Pracovník pneuservisu',
    'service_technician': 'Prijímací technik',
    'process_engineer': 'Procesný inžinier',
    'automotive_product_manager': 'Produktový manažér v automobilovom priemysle',
    'automotive_project_manager': 'Projektový manažér v automobilovom priemysle',
    'technologist': 'Technológ',
    'service_manager': 'Vedúci servisu',
    'miner': 'Baník',
    'mining_technician': 'Banský technik',
    'metallurgist': 'Hutník',
    'metallurgical_engineer': 'Hutný inžinier',
    'designer': 'Projektant',
    'account_manager': 'Account manager',
    'back_office_specialist': 'Back office špecialista',
    'compliance_specialist': 'Compliance špecialista',
    'custody_specialist': 'Custody špecialista',
    'dealer_trader': 'Dealer trader',
    'financial_analyst': 'Finančný analytik',
    'financial_controller': 'Finančný kontrolór',
    'financial_advisor': 'Finančný poradca',
    'mortgage_advisor': 'Hypotekárny poradca',
    'investment_advisor': 'Investičný poradca',
    'client_advisor': 'Klientský poradca',
    'leasing_advisor': 'Leasingový poradca',
    'insurance_claim_appraiser': 'Odhadca poistnej udalosti',
    'insurance_liquidator': 'Poistný likvidátor',
    'actuary': 'Poistný matematik',
    'insurance_technician': 'Poistný technik',
    'insurance_advisor': 'Poisťovací poradca',
    'cashier': 'Pokladník',
    'treasury_payment_operations_worker': 'Pracovník treasury/platobný styk',
    'teller': 'Priehradkový pracovník',
    'private_banker': 'Privátny bankár',
    'product_manager': 'Produktový manažér',
    'project_manager': 'Projektový manažér',
    'payment_cards_officer': 'Referent platobných kariet',
    'receivables_management_officer': 'Referent správy pohľadávok',
    'insurance_management_officer': 'Referent správy poistenia',
    'premium_collection_officer': 'Referent výberu poistného',
    'branch_manager': 'Riaditeľ pobočky',
    'risk_analyst': 'Risk analytik',
    'risk_manager': 'Risk manažér',
    'risk_specialist': 'Risk specialist',
    'insurance_payer_control_specialist': 'Špecialista kontroly platiteľov poistného',
    'underwriter': 'Underwriter/upisovateľ poistného rizika',
    'credit_officer': 'Úverový pracovník',
    'head_of_leasing_department': 'Vedúci leasingového oddelenia',
    'department_manager': 'Vedúci oddelenia',
    'security_manager': 'Bezpečnostný manažér',
    'security_technician': 'Bezpečnostný technik',
    'firefighter_rescuer': 'Hasič, záchranár',
    'security_service_manager': 'Manažér bezpečnostnej služby',
    'police_officer': 'Policajt',
    'fire_safety_technician': 'Požiarny technik',
    'security_service_worker': 'Pracovník bezpečnostnej služby',
    'guard_service_worker': 'Pracovník strážnej služby',
    'security_service_director': 'Riaditeľ bezpečnostnej služby',
    'health_safety_technician': 'Technik BOZP',
    'fire_protection_technician': 'Technik požiarnej ochrany',
    'prison_guard': 'Väzenský dozorca',
    'soldier': 'Vojak',
    'surveyor': 'Anketár',
    'temporary_worker': 'Brigádnik',
    'helper': 'Pomocný pracovník',
    'laborer': 'Robotník',
    'cleaner': 'Upratovačka',
    'porter': 'Vrátnik',
    'leisure_animator': 'Animátor voľného času',
    'barista': 'Barista',
    'bartender': 'Barman',
    'waiter': 'Čašník',
    'housekeeper': 'Chyžná',
    'concierge': 'Concierge',
    'confectioner': 'Cukrár',
    'f_b_manager': 'F&B manažér',
    'facility_manager': 'Facility manager',
    'front_desk_manager': 'Front desk manažér',
    'hostess': 'Hosteska',
    'croupier': 'Krupiér',
    'cook': 'Kuchár',
    'hotel_manager': 'Manažér hotela',
    'hotel_pension_sales_department_manager': 'Manažér obchodného oddelenia hotela, penziónu',
    'butcher': 'Mäsiar',
    'baker': 'Pekár',
    'pizza_maker': 'Pizzér',
    'lifeguard': 'Plavčík',
    'kitchen_helper': 'Pomocná sila v kuchyni',
    'assistant_cook': 'Pomocný kuchár',
    'fast_food_worker': 'Pracovník rýchleho občerstvenia',
    'ticket_seller': 'Predajca leteniek',
    'travel_agent': 'Predajca zájazdov',
    'operations_manager': 'Prevádzkar',
    'chef': 'Šéfkuchár',
    'sommelier': 'Sommeliér',
    'tourist_guide': 'Sprievodca v cestovnom ruchu',
    'steward_flight_attendant': 'Steward, letuška',
    'facility_operations_manager': 'Vedúci prevádzky',
    'chemical_engineer': 'Chemický inžinier',
    'chemical_laboratory_technician': 'Chemický laborant',
    'chemist': 'Chemik',
    'chemical_industry_machinery_operator': 'Operátor strojov a zariadení v chemickom priemysle',
    'chemical_industry_technologist': 'Technológ v chemickom priemysle',
    'customs_declarant': 'Colný deklarant',
    'dispatcher': 'Dispečer',
    'scheduler': 'Disponent',
    'transportation_engineer': 'Dopravný inžinier',
    'shipping_clerk': 'Expedient',
    'ship_captain': 'Kapitán lode',
    'logistics_transport_supply_controller': 'Kontrolór v logistike, doprave a zásobovaní',
    'coordinator': 'Koordinátor',
    'courier': 'Kuriér',
    'logistician': 'Logistik',
    'logistics_manager': 'Manažér logistiky',
    'fleet_manager': 'Manažér vozového parku',
    'buyer': 'Nákupca',
    'postal_carrier': 'Poštový doručovateľ',
    'shipping_worker': 'Pracovník lodnej prepravy',
    'transport_project_manager': 'Projektový manažér v doprave',
    'logistics_director': 'Riaditeľ logistiky',
    'train_driver': 'Rušňovodič',
    'warehouse_worker': 'Skladník',
    'freight_forwarder': 'Špeditér, prepravca',
    'transport_manager': 'Vedúci dopravy',
    'purchasing_manager': 'Vedúci nákupu',
    'sales_department_manager': 'Vedúci odbytu',
    'post_office_manager': 'Vedúci pošty',
    'warehouse_manager': 'Vedúci skladu',
    'bus_driver': 'Vodič autobusu',
    'truck_driver': 'Vodič kamiónovej prepravy',
    'public_transport_driver': 'Vodič MHD',
    'truck_driver_cargo': 'Vodič nákladného vozidla',
    'car_driver': 'Vodič osobného vozidla',
    'forklift_driver': 'Vodič vysokozdvižného vozíka',
    'stationmaster': 'Vozmajster',
    'train_dispatcher': 'Výpravca',
    'supplier': 'Zásobovač',
    'delivery_driver': 'Závozník',
    'upholsterer': 'Čalúnnik',
    'wood_engineer': 'Drevársky inžinier',
    'wood_technician': 'Drevársky technik',
    'furniture_designer': 'Konštruktér',
    'furniture_maker': 'Nábytkár',
    'sawyer': 'Pilčík',
    'wood_processing_industry_designer': 'Projektant v drevospracujúcom priemysle',
    'carpenter': 'Stolár',
    'audit_assistant': 'Asistent auditora',
    'auditor': 'Auditor',
    'broker': 'Broker',
    'tax_advisor': 'Daňový poradca',
    'economist': 'Ekonóm',
    'invoice_clerk': 'Fakturant',
    'financial_agent': 'Finančný agent',
    'financial_manager': 'Finančný manažér',
    'chief_financial_officer': 'Finančný riaditeľ',
    'fundraiser': 'Fundraiser',
    'chief_accountant': 'Hlavný účtovník',
    'mortgage_specialist': 'Hypotekárny špecialista',
    'consultant': 'Konzultant',
    'eu_projects_coordinator': 'Koordinátor EÚ projektov',
    'payroll_accountant': 'Mzdový účtovník',
    'business_analyst': 'Obchodný analytik',
    'personal_banker': 'Osobný bankár',
    'payment_operations_worker': 'Pracovník platobného styku',
    'settlement_officer': 'Referent zúčtovania',
    'head_of_economic_department': 'Riaditeľ ekonomického úseku',
    'budget_planner_calculator': 'Rozpočtár, kalkulant',
    'invoicing_payments_specialist': 'Špecialista fakturácie a platieb',
    'financial_markets_specialist': 'Špecialista finančných trhov',
    'receivables_specialist': 'Špecialista pohľadávok',
    'reporting_specialist': 'Špecialista reportingu',
    'statistician': 'Štatistik',
    'accountant': 'Účtovník',
    'credit_specialist': 'Úverový špecialista',
    'electrician': 'Elektrikár',
    'electrical_installer': 'Elektromontér',
    'electronics_technician': 'Elektronik',
    'electrical_engineer': 'Elektrotechnický inžinier',
    'electrical_technician': 'Elektrotechnik',
    'energy_specialist': 'Energetik',
    'simulation_engineer': 'Inžinier simulácii',
    'integrated_circuit_designer': 'Konštruktér integrovaných obvodov',
    'aircraft_mechanic': 'Letecký mechanik',
    'refrigeration_equipment_mechanic': 'Mechanik chladiarenských zariadení',
    'mechatronics_specialist': 'Mechatronik',
    'energy_equipment_operator': 'Obsluha energetických zariadení',
    'repairman': 'Opravár',
    'lighting_technician': 'Osvetľovač',
    'electrical_engineering_project_manager': 'Projektový manažér v oblasti elektrotechniky',
    'energy_project_manager': 'Projektový manažér v oblasti energetiky',
    'inspection_technician': 'Revízny technik',
    'service_engineer': 'Servisný inžinier',
    'electrical_service_technician': 'Servisný technik',
    'test_technician': 'Skúšobný technik',
    'network_strategy_specialist': 'Špecialista stratégie siete',
    'system_engineer': 'Systémový inžinier',
    'technical_inspection_technician': 'Technik STK, EK',
    'technical_manager': 'Technický manažér',
    'technician': 'Technik',
    'sound_engineer': 'Zvukár',
    'telecommunications_network_designer': 'Dizajnér telekomunikačných sietí',
    'computer_technician': 'Počítačový technik',
    'industrial_robot_programmer': 'Programátor priemyselných robotov',
    'transmission_network_analysis_development_specialist': 'Špecialista analýz a rozvoja prenosových sietí',
    'abap_programmer': 'ABAP programátor',
    'android_programmer': 'Android programátor',
    'backend_developer': 'Back-end programátor',
    'business_intelligence_specialist': 'Business Intelligence Specialist',
    'c_programmer': 'C programátor',
    'crm_specialist': 'CRM špecialista',
    'database_analyst': 'Databázový analytik',
    'database_specialist': 'Databázový špecialista',
    'devops_engineer': 'DevOps Engineer',
    'front_end_programmer': 'Front-end programátor',
    'help_desk_worker': 'Help desk pracovník',
    'ios_programmer': 'iOS programátor',
    'it_analyst': 'IT analytik',
    'it_architect': 'IT architekt',
    'it_consultant': 'IT konzultant',
    'it_product_manager': 'IT produktový manažér',
    'it_project_manager': 'IT projektový manažér',
    'it_director': 'IT riaditeľ',
    'it_tester': 'IT tester',
    'java_programmer': 'Java programátor',
    'javascript_programmer': 'Javascript programátor',
    'net_programmer': '.NET programátor',
    'objective_c_programmer': 'Objective-C programátor',
    'oracle_programmer': 'Oracle programátor',
    'perl_programmer': 'Perl programátor',
    'php_programmer': 'PHP programátor',
    'plc_programmer': 'PLC programátor',
    'junior_programmer': 'Pomocný programátor',
    'sales_support_worker': 'Pracovník podpory predaja',
    'programmer': 'Programátor',
    'python_programmer': 'Python programátor',
    'sap_product_manager': 'SAP Produktový Manažér',
    'sap_specialist': 'SAP Špecialista',
    'scrum_master': 'Scrum Master',
    'software_engineer': 'Softvérový inžinier',
    'end_device_testing_specialist': 'Špecialista testovania koncových zariadení',
    'technical_writer': 'Technical writer',
    'user_experience_expert': 'User Experience Expert',
    'webmaster': 'Webmaster',
    'ict_specialist': 'ICT špecialista',
    'it_technical_support_specialist': 'IT/Technical Support Specialist',
    'network_modeling_specialist': 'Špecialista modelovania sietí',
    'it_security_specialist': 'Špecialista na IT bezpečnosť',
    'fraud_prevention_specialist': 'Špecialista predchádzania podvodom',
    'information_system_administrator': 'Správca informačného systému',
    'network_administrator': 'Správca počítačovej siete',
    'system_administrator': 'Systémový administrátor',
    'hr_assistant': 'HR asistent',
    'hr_business_partner': 'HR Business Partner',
    'hr_generalist': 'HR Generalist',
    'hr_coordinator': 'HR Koordinátor',
    'lecturer_trainer': 'Lektor, školiteľ',
    'human_resources_manager': 'Manažér ľudských zdrojov',
    'hr_specialist': 'Personalista',
    'personnel_consultant': 'Personálny konzultant',
    'personnel_manager': 'Personálny manažér',
    'hr_director': 'Personálny riaditeľ',
    'work_psychologist': 'Pracovný psychológ',
    'psychologist': 'Psychológ',
    'recruiter_selection_specialist': 'Recruiter, špecialista výberov',
    'head_of_hr_department': 'Riaditeľ personálneho úseku, personálny riaditeľ',
    'compensation_specialist': 'Špecialista pre odmeňovanie',
    'training_education_specialist': 'Špecialista pre vzdelávanie a tréningy',
    'quality_inspector': 'Inšpektor',
    'quality_engineer': 'Inžinier kvality',
    'quality_controller': 'Kontrolór kvality',
    'quality_manager': 'Manažér kvality',
    'quality_planner': 'Plánovač kvality',
    'quality_iso_director': 'Riaditeľ kvality a ISO',
    'iso_specialist': 'Špecialista ISO',
    'brand_manager': 'Brand manager',
    'copywriter': 'Copywriter, reklamný textár',
    'dtp_operator': 'DTP operátor',
    'event_manager': 'Event manager',
    'graphic_designer': 'Grafický dizajnér',
    'graphic_artist': 'Grafik',
    'spokesperson': 'Hovorca',
    'complaints_department_manager': 'Manažér reklamačného oddelenia',
    'marketing_manager': 'Marketingový manažér',
    'marketing_worker': 'Marketingový pracovník',
    'marketing_director': 'Marketingový riaditeľ',
    'marketing_specialist': 'Marketingový špecialista',
    'multimedia_specialist': 'Multimedia Specialist',
    'ppc_specialist': 'PPC špecialista',
    'pr_manager': 'PR manažér',
    'advertising_marketing_product_manager': 'Produktový manažér v oblasti reklamy a marketingu',
    'marketing_project_manager': 'Projektový manažér v marketingu',
    'market_research_project_manager': 'Projektový manažér v oblasti prieskumu trhu',
    'promoter': 'Promotér',
    'creative_director': 'Riaditeľ kreatívy',
    'seo_analyst': 'SEO analytik',
    'internal_communication_specialist': 'Špecialista internej komunikácie',
    'marketing_analysis_specialist': 'Špecialista marketingových analýz',
    'visual_merchandiser': 'Visual merchandiser / Vizualista',
    'relationship_manager': 'Vzťahový manažér',
    'web_designer': 'Web dizajnér',
    'inventory_commission_member': 'Člen inventúrnej komisie',
    'country_manager_director': 'Country manager / director',
    'demand_planner': 'Demand planner',
    'merchandiser_stock_assistant': 'Dokladač tovaru/merchendiser',
    'merchandiser': 'Dokladač tovaru, merchandiser',
    'e_commerce_specialist': 'E-commerce specialist',
    'key_account_manager': 'Key account manager',
    'store_branch_manager': 'Manažér prevádzky / pobočky',
    'salesperson': 'Obchodník, predajca',
    'sales_manager': 'Obchodný manažér',
    'sales_representative_officer': 'Obchodný referent',
    'sales_director': 'Obchodný riaditeľ',
    'sales_representative': 'Obchodný zástupca',
    'specialist_salesperson': 'Odborný predajca',
    'complaints_department_worker': 'Pracovník reklamačného oddelenia',
    'pyrotechnics_seller': 'Predajca pyrotechniky',
    'team_leader': 'Predák',
    'shop_assistant': 'Predavač',
    'retail_operations_manager': 'Prevádzkový manažér',
    'regional_area_manager': 'Regionálny / Oblastný manažér',
    'telemarketing_worker': 'Telemarketingový pracovník',
    'sales_team_manager': 'Vedúci obchodnej skupiny',
    'store_facility_manager': 'Vedúci prevádzky, vedúci predajne',
    'complaints_department_head': 'Vedúci reklamačného úseku',
    'store_section_manager': 'Vedúci úseku predajne',
    'deputy_store_facility_manager': 'Zástupca vedúceho predajne/prevádzky',
    'agronomist': 'Agronóm',
    'animal_breeder_caretaker': 'Chovateľ, ošetrovateľ zvierat',
    'milker': 'Dojička',
    'forester': 'Lesník',
    'forest_engineer': 'Lesný inžinier',
    'forest_technician': 'Lesný technik',
    'soil_scientist': 'Pôdoznalec',
    'agricultural_engineer_agronomist': 'Poľnohospodársky inžinier, agronóm',
    'agricultural_technician': 'Poľnohospodársky technik',
    'agricultural_technologist': 'Poľnohospodársky technológ',
    'cooperative_chairman': 'Predseda družstva',
    'farmer': 'Roľník',
    'tractor_combine_operator': 'Traktorista, kombajnista',
    'veterinary_assistant': 'Veterinárny asistent',
    'veterinarian': 'Veterinárny lekár',
    'gardener': 'Záhradník',
    'landscape_architect': 'Záhradný architekt',
    'picker': 'Zberač',
    'zootechnician': 'Zootechnik',
    'food_engineer': 'Potravinársky inžinier',
    'food_technician': 'Potravinársky technik',
    'food_technologist': 'Potravinársky technológ',
    'trainee_lawyer': 'Advokátsky koncipient',
    'bailiff': 'Exekútor',
    'bailiff_trainee': 'Exekútorský koncipient',
    'registrar': 'Matrikár',
    'notary': 'Notár',
    'notary_trainee': 'Notársky koncipient',
    'paralegal_law_student': 'Paralegal – študent práva',
    'lawyer': 'Právnik',
    'legal_assistant': 'Právny asistent',
    'regulatory_affairs_manager': 'Regulatory affairs manager',
    'regulatory_affairs_specialist': 'Regulatory affairs specialist',
    'enforcement_specialist': 'Špecialista zaistenia',
    'judge': 'Sudca',
    'court_expert': 'Súdny znalec',
    'head_of_legal_department': 'Vedúci právneho oddelenia',
    'proofreader': 'Korektor',
    'translation_agency_business_manager': 'Obchodný manažér prekladateľskej agentúry',
    'translator': 'Prekladateľ',
    'interpreter': 'Tlmočník',
    'teaching_assistant': 'Asistent učiteľa',
    'phd_student': 'Doktorand',
    'driving_instructor': 'Inštruktor autoškoly',
    'speech_therapist': 'Logopéd',
    'vocational_education_master': 'Majster odbornej výchovy',
    'professor': 'Profesor',
    'school_principal': 'Riaditeľ školy',
    'school_caretaker': 'Školník',
    'social_worker': 'Sociálny pracovník',
    'special_education_teacher': 'Špeciálny pedagóg',
    'sports_coach': 'Športový tréner',
    'primary_school_teacher_grades_1_4': 'Učiteľ 1.stupňa ZŠ',
    'primary_school_teacher_grades_5_9': 'Učiteľ 2.stupňa ZŠ',
    'secondary_school_teacher': 'Učiteľ na strednej škole',
    'university_teacher': 'Učiteľ na vysokej škole',
    'kindergarten_teacher': 'Učiteľka v materskej škole',
    'educator': 'Vychovávateľka',
    'florist_decorator': 'Aranžér',
    'au_pair': 'Au-pair',
    'coach': 'Coach',
    'photographer': 'Fotograf',
    'house_keeper': 'Gazdiná',
    'watchmaker': 'Hodinár',
    'houseman': 'Houseman',
    'plumber': 'Inštalatér',
    'interior_designer': 'Interiérový návrhár',
    'hairdresser': 'Kaderník, kaderníčka',
    'fitness_trainer': 'Kondičný tréner',
    'blacksmith': 'Kováč',
    'beautician': 'Kozmetička',
    'stoker': 'Kurič',
    'florist': 'Kvetinár',
    'painter': 'Maliar, natierač',
    'gas_station_attendant': 'Obsluha čerpacej stanice',
    'wedding_planner': 'Organizátor svadieb',
    'pedicurist_manicurist': 'Pedikérka, manikérka',
    'stylist_makeup_artist': 'Stylista, vizážista',
    'maintenance_worker': 'Údržbár',
    'goldsmith_jeweler': 'Zlatník, klenotník',
    'caregiver': 'Opatrovateľka',
    'professional_parent': 'Profesionálny rodič',
    'customs_officer': 'Colník',
    'general_state_advisor': 'Generálny štátny radca',
    'chief_advisor': 'Hlavný radca',
    'chief_officer': 'Hlavný referent',
    'chief_state_advisor': 'Hlavný štátny radca',
    'expert_advisor': 'Odborný radca',
    'expert_officer': 'Odborný referent',
    'advisor': 'Radca',
    'department_director': 'Riaditeľ odboru',
    'independent_advisor': 'Samostatný radca',
    'independent_officer': 'Samostatný referent',
    'public_procurement_specialist': 'Špecialista verejného obstarávania',
    'professional_soldier': 'Vojak z povolania',
    'state_administration_employee': 'Zamestnanec štátnej správy',
    'public_administration_employee': 'Zamestnanec verejnej správy',
    'architect': 'Architekt',
    'interior_architect': 'Bytový architekt',
    'geologist': 'Geológ',
    'insulation_worker': 'Izolatér',
    'tinsmith_roofer': 'Klampiar, pokrývač',
    'scaffolder': 'Lešenár',
    'installer': 'Montážnik',
    'mason_tiler': 'Murár, obkladač',
    'real_estate_appraiser': 'Odhadca nehnuteľností',
    'window_installer_glazier': 'Okenár, sklár',
    'construction_machinery_operator': 'Operátor stavebných strojov',
    'floor_layer_paver': 'Podlahár, dlaždič',
    'pipe_fitter': 'Potrubár',
    'hvac_worker': 'Pracovník vzduchotechniky a klimatizácie',
    'industrial_climber': 'Priemyselný horolezec',
    'construction_planner': 'Prípravár stavieb',
    'mep_designer': 'Projektant TZB',
    'construction_project_manager': 'Projektový manažér v stavebníctve',
    'real_estate_agent': 'Realitný maklér',
    'construction_estimator': 'Rozpočtár/kalkulant stavieb',
    'drywall_installer': 'Sadrokartonista',
    'building_manager': 'Správca budov',
    'structural_engineer': 'Statik',
    'construction_supervisor': 'Stavbyvedúci',
    'civil_engineer': 'Stavebný inžinier',
    'construction_foreman': 'Stavebný majster',
    'construction_technician': 'Stavebný technik',
    'construction_locksmith': 'Stavebný zámočník',
    'construction_carpenter': 'Tesár',
    'locksmith': 'Zámočník',
    'land_surveyor': 'Zememerač',
    'crane_operator': 'Žeriavnik',
    'welder': 'Zvárač',
    'grinder': 'Brusič',
    'cad_designer': 'CAD návrhár',
    'cnc_programmer': 'CNC programátor',
    'milling_machine_operator_turner': 'Frézár, sústružník',
    'metal_worker': 'Obrábač kovov',
    'engineering_machinery_operator': 'Operátor strojov a zariadení v strojárstve',
    'process_manager': 'Procesný manažér',
    'engineering_project_manager': 'Projektový manažér v strojárstve',
    'machinist': 'Strojník',
    'mechanical_engineer': 'Strojný inžinier',
    'mechanical_technician': 'Strojný technik',
    'mechanical_locksmith': 'Strojný zámočník',
    'technical_worker': 'Technický pracovník',
    'technical_process_engineer': 'Technický procesný inžinier',
    'technical_designer': 'Technický projektant',
    'technical_project_manager': 'Technický projektový manažér',
    'technical_director': 'Technický riaditeľ',
    'non_destructive_testing_technician': 'Technik nedeštruktívnych skúšok',
    'head_of_technical_department': 'Vedúci technického oddelenia',
    'call_center_manager': 'Manažér call centra',
    'is_product_manager': 'Produktový manažér IS',
    'telecommunications_project_manager': 'Projektový manažér v telekomunikáciách',
    'call_center_director': 'Riaditeľ call centra',
    'oss_bss_specialist': 'Špecialista OSS/BSS',
    'radio_network_planning_specialist': 'Špecialista plánovania rádiovej siete',
    'network_services_operations_specialist': 'Špecialista prevádzky sietí a služieb',
    'radio_network_optimization_specialist': 'Špecialista optimalizácie rádiovej siete',
    'mobile_network_development_specialist': 'Špecialista rozvoja mobilnej siete',
    'communication_systems_specialist': 'Špecialista spojovacích systémov',
    'telecommunications_product_development_specialist': 'Špecialista vývoja telekomunikačných produktov',
    'telecommunications_services_development_specialist': 'Špecialista vývoja telekomunikačných služieb',
    'call_center_supervisor': 'Supervízor call centra',
    'telecommunications_technical_worker': 'Technický pracovník v telekomunikáciách',
    'customer_service': 'Zákaznícky servis',
    'furrier': 'Kožušník',
    'tailor_seamstress': 'Krajčír, šička',
    'shoemaker': 'Obuvník',
    'fashion_designer': 'Odevný návrhár',
    'clothing_industry_machinery_operator': 'Operátor strojov a zariadení v odevnom priemysle',
    'cutter': 'Strihač',
    'creative_designer': 'Dizajnér',
    'cameraman_editor': 'Kameraman, strihač',
    'cultural_officer': 'Kultúrny referent',
    'makeup_artist_wig_maker': 'Maskér, parochniar',
    'fashion_stylist': 'Módny návrhár',
    'set_designer': 'Scénograf',
    'singer_actor_musician': 'Spevák, herec, hudobník',
    'dancer_choreographer': 'Tanečník, choreograf',
    'art_designer': 'Umelecký dizajnér',
    'art_photographer': 'Umelecký fotograf',
    'art_painter': 'Umelecký maliar',
    'cultural_institution_employee': 'Zamestnanec kultúrnej inštitúcie',
    'biologist': 'Biológ',
    'research_chemist': 'Chemik',
    'physicist': 'Fyzik',
    'librarian': 'Knihovník',
    'laboratory_technician': 'Laborant',
    'metrologist': 'Metrológ',
    'microbiologist': 'Mikrobiológ',
    'sociologist': 'Sociológ',
    'research_scientific_worker': 'Výskumný a vedecký pracovník',
    'ecologist_environmentalist': 'Ekológ, environmentalista',
    'environmentalist': 'Environmentalista',
    'geodesist': 'Geodét',
    'water_management_engineer': 'Vodohospodársky inžinier',
    'water_management_technician': 'Vodohospodársky technik',
    'country_director_manager': 'Country director, manager',
    'ceo': 'Generálny riaditeľ',
    'executive_director': 'Výkonný riaditeľ',
    'packer': 'Balič',
    'production_foreman': 'Majster výroby',
    'assembler': 'Montážnik, montér',
    'cnc_machine_setter': 'Nastavovač CNC strojov',
    'machine_setter': 'Nastavovač strojov',
    'tool_maker': 'Nástrojár',
    'work_standards_specialist': 'Normovač práce',
    'machine_operator': 'Operátor strojov a zariadení',
    'production_planner': 'Plánovač výroby',
    'maintenance_manager': 'Vedúci údržby',
    'production_director': 'Výrobný riaditeľ',
    'foundry_worker': 'Zlievač',
    'client_service_worker': 'Klientsky pracovník',
    'customer_service_manager': 'Manažér zákazníckeho servisu',
    'help_desk_support_worker': 'Pracovník help desku',
    'customer_support_specialist': 'Špecialista podpory zákazníkov',
    'nutrition_assistant': 'Asistent výživy',
    'dental_hygienist': 'Dentálna hygienička',
    'home_caregiver': 'Domáca opatrovateľka',
    'drug_safety_specialist': 'Drug Safety Specialist',
    'pharmacist': 'Farmaceut',
    'pharmaceutical_laboratory_technician': 'Farmaceutický laborant',
    'physiotherapist': 'Fyzioterapeut',
    'head_nurse': 'Hlavná sestra',
    'hygienist': 'Hygienik',
    'laboratory_diagnostician': 'Laboratórny diagnostik',
    'doctor': 'Lekár',
    'masseur': 'Masér',
    'medical_advisor': 'Medical advisor',
    'medical_pharmaceutical_representative': 'Medicínsky/farmaceutický reprezentant',
    'clinical_trial_monitor': 'Monitor klinických štúdií',
    'optician': 'Očný optik',
    'optometrist': 'Optometrista',
    'orthopedic_technician': 'Ortopedický technik',
    'midwife': 'Pôrodná asistentka',
    'healthcare_product_manager': 'Produktový manažér v oblasti zdravotníctva',
    'healthcare_project_manager': 'Projektový manažér v oblasti zdravotníctva',
    'radiologist': 'Rádiológ',
    'radiology_assistant': 'Radiologický asistent',
    'audit_nurse': 'Revízna sestra',
    'audit_pharmacist': 'Revízny farmaceut',
    'audit_doctor': 'Revízny lekár',
    'healthcare_facility_director': 'Riaditeľ zdravotníckeho zariadenia',
    'orderly': 'Sanitár',
    'nurse': 'Sestra',
    'medicine_warehouse_worker': 'Skladník liečiv',
    'healthcare_purchasing_specialist': 'Špecialista nákupu zdravotnej starostlivosti',
    'health_program_development_specialist': 'Špecialista vývoja programov zdravia',
    'support_health_activities_specialist': 'Špecialista podporných a zdravotných činností',
    'public_health_specialist': 'Verejný zdravotník',
    'senior_nurse': 'Vrchná sestra',
    'registered_nurse': 'Zdravotná sestra',
    'medical_laboratory_technician': 'Zdravotnícky laborant',
    'paramedic': 'Zdravotnícky záchranár',
    'healthcare_assistant': 'Zdravotný asistent',
    'dental_assistant': 'Zubný asistent',
    'dental_laboratory_technician': 'Zubný laborant',
    'dentist': 'Zubný lekár',
    'dental_technician': 'Zubný technik',
    'editor': 'Editor',
    'editor_in_chief': 'Hlavný redaktor',
    'bookbinder': 'Knihár',
    'advertising_manager': 'Manažér inzercie',
    'media_buyer': 'Media buyer',
    'media_planner': 'Media planner',
    'journalist': 'Novinár',
    'producer': 'Produkčný',
    'production_manager': 'Produkčný manažér',
    'editorial_writer': 'Redaktor',
    'publishing_director': 'Riaditeľ vydavateľstva',
    'chief_editor': 'Šéfredaktor',
    'social_media_specialist': 'Social media specialist',
    'printer': 'Tlačiar',
    'deputy_editor': 'Zástupca redaktora'
  }
};